import { initializeApp } from "firebase/app";
import { initializeFirestore, persistentLocalCache } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAVoY_pP2PHFs8TCQR5cXx7K7rc6UlcJzs",
  authDomain: "tjvjik.firebaseapp.com",
  projectId: "tjvjik",
  storageBucket: "tjvjik.firebasestorage.app",
  messagingSenderId: "603670540744",
  appId: "1:603670540744:web:f35be67a6619719893d0fd"
};


const app = initializeApp(firebaseConfig);

// Միացնում ենք Local Cache (Offline Persistence)
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache()
});
export const auth = getAuth(app);
export const storage = getStorage(app);
